import { ReactNode, ChangeEvent } from 'react'

import classNames from 'classnames'
import useId from '../hooks/useId'
import Icon from './Icon'

interface Props {
  className?: string
  label: string | ReactNode
  name?: string
  checked?: boolean
  disabled?: boolean
  error?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  testId?: string
}

export default function Checkbox({
  className,
  label,
  name,
  checked = false,
  disabled = false,
  error = false,
  onChange,
  onBlur,
  testId,
}: Props) {
  const id = useId('Checkbox')

  return (
    <label htmlFor={id} className={classNames('Checkbox', { disabled }, className)}>
      <input
        type="checkbox"
        id={id}
        name={name}
        className="Checkbox__input"
        disabled={disabled}
        aria-checked={checked}
        aria-invalid={error}
        checked={checked}
        onBlur={onBlur}
        onChange={onChange}
        data-testid={testId}
      />
      <div className={classNames('Checkbox__iconContainer', { error, checked, disabled })}>
        {checked && <Icon name="FunBoldCheck" size={16} />}
      </div>
      <span className="Checkbox__label">{label}</span>
    </label>
  )
}
